import { useSecureContextStore } from 'scbk-services/shared-context/stores/secureContextStore';

import type { SecureContext } from 'scbk-services/types/shared-context/secure-context';

const useSecureContext = () => {
    const getSecureContext = useSecureContextStore((state) => state.getSecureContext);
    const resetSecureContext = useSecureContextStore((state) => state.resetSecureContext);
    const setSignSecureContext = useSecureContextStore((state) => state.setSignContext);
    const setTokensSecureContext = useSecureContextStore((state) => state.setTokensContext);
    const setKeypadSecureContext = useSecureContextStore((state) => state.setKeypadContext);
    const resetKeypadSecureContext = useSecureContextStore((state) => state.resetKeypadContext);
    const setSubKeypadSecureContext = useSecureContextStore((state) => state.setSubKeypadContext);
    const resetSubKeypadSecureContext = useSecureContextStore(
        (state) => state.resetSubKeypadContext,
    );
    const resetKeypadPlainMapSecureContext = useSecureContextStore(
        (state) => state.resetKeypadPlainMapSecureContext,
    );

    const getContext = (): SecureContext.Context => {
        return getSecureContext();
    };

    const resetContext = () => {
        resetSecureContext();
    };

    const setSignContext = (context: SecureContext.SignContext): void => {
        setSignSecureContext(context);
    };

    const setTokensContext = (context: SecureContext.TokensContext): void => {
        setTokensSecureContext(context);
    };

    const setKeypadContext = (context: SecureContext.KeypadContext): void => {
        setKeypadSecureContext(context);
    };

    const setSubKeypadContext = (context: SecureContext.SubKeypadContext): void => {
        setSubKeypadSecureContext(context);
    };

    return {
        getContext,
        resetContext,
        setSignContext,
        setTokensContext,
        setKeypadContext, // set 키패드 context
        resetKeypadSecureContext, // 리셋 키패드 컨텍스트
        setSubKeypadContext, // set Sub 키패드 context
        resetSubKeypadSecureContext, // 리셋 Sub 키패드 context
        resetKeypadPlainMapSecureContext, // 리셋 확장 E2E context
    };
};

export default useSecureContext;
